export const initialStateCedulas = {
    name: '', age: '', sex: '',
    date: null, creationDate: null,
    state: '', municipality: '',
    page: 1, totalPages: 0,
    loadingSearch: false, loadingState: false, loadingEstatusCedula: false,
};

export const cedulasReducer = (state, action) => {
    switch (action.type) {
        case 'SET_CEDULA_DATA':
            return {
                ...state,
                [action.field]: action.value,
            };
        case 'LOADING':
            return {
                ...state,
                [action.field]: true,
            };
        case 'FINISH_LOADING':
            return {
                ...state,
                [action.field]: false,
            };
        case 'RESET_CEDULA_DATA':
            return initialStateCedulas;
        default:
            return state;
    }
};